import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export function buildEntityProgramsListTableStateStorageKey(entityId: number) {
    return `entityProgramsListForEntity-${entityId}`;
}

export const ENTITY_PROGRAMS_LIST_COLUMN_IDS = {
    NAME: "name",
    CONTROL_COUNT: "controlCount",
    STATUS: "status",
    TAGS: "tags",
} as const;

export const entityProgramsListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: ENTITY_PROGRAMS_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const entityProgramsListColumnFiltersCodecMap = {
    [ENTITY_PROGRAMS_LIST_COLUMN_IDS.NAME]: withModeCodec(encodedArrayCodec),
    [ENTITY_PROGRAMS_LIST_COLUMN_IDS.STATUS]: withModeCodec(encodedArrayCodec),
    [ENTITY_PROGRAMS_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
};
